(() => {

  const CONFIG = window.NUPEP_AGE_GATE_CONFIG || {};
  const KEY = CONFIG.key || "nupep_age_verified";

  function gate() {
    return document.getElementById("ageGateWrapper");
  }

  function verified() {
    try {
      return localStorage.getItem(KEY) === "true";
    } catch(e) {
      return false;
    }
  }

  function lock() {
    document.documentElement.classList.add("age-locked");
  }

  function unlock() {
    document.documentElement.classList.remove("age-locked");
  }

  function setupEvents() {

    const confirmBtn = document.getElementById("ageConfirm");
    const denyBtn = document.getElementById("ageDeny");
    const ageCheck = document.getElementById("ageCheck");
    const researchCheck = document.getElementById("researchCheck");

    if (!confirmBtn) return;
    if (!denyBtn) return;
    if (!ageCheck) return;
    if (!researchCheck) return;

    function validate() {
      confirmBtn.disabled =
        !(ageCheck.checked && researchCheck.checked);
    }

    validate();

    ageCheck.addEventListener("change", validate);
    researchCheck.addEventListener("change", validate);

    confirmBtn.addEventListener("click", () => {

      localStorage.setItem(KEY, "true");

      unlock();

      const el = gate();

      if (el) {
        el.style.display = "none";
      }

    });

    denyBtn.addEventListener("click", () => {
      window.location.href = "https://google.com";
    });

  }

  function init() {

    const el = gate();

    if (!el) {
      console.log("AGE GATE NOT FOUND");
      return;
    }

    // CUSTOMIZER SAFE MODE
    if (window.Shopify && Shopify.designMode) {
      unlock();
      return;
    }

    // VERIFIED USER
    if (verified()) {
      unlock();
      el.style.display = "none";
      return;
    }

    // SHOW GATE
    lock();

    el.style.display = "flex";

    setupEvents();

  }

  // START
  document.addEventListener("DOMContentLoaded", init);

  // SHOPIFY SECTION RELOADS
  document.addEventListener("shopify:section:load", init);

})();